// extracted by mini-css-extract-plugin
module.exports = {"table":"ProductSection_table__vHS95","cell":"ProductSection_cell__qCb5L"};